/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPlayerTrackNext = createReactComponent(
  "player-track-next",
  "IconPlayerTrackNext",
  [
    ["path", { d: "M3 5v14l8 -7z", key: "svg-0" }],
    ["path", { d: "M14 5v14l8 -7z", key: "svg-1" }]
  ]
);

export { IconPlayerTrackNext as default };
//# sourceMappingURL=IconPlayerTrackNext.js.map
